<template>
    
  <div class="my-plan-container">
    <!-- 渐变动画页头 -->
    <div class="gradient-header">
      <div class="checkerboard-overlay"></div>
      <div class="header-content">
        <div class="header-icon">
          <i class="el-icon-shopping-cart-2"></i>
        </div>
        <span>我的计划</span>
      </div>
    </div>

    <!-- Tab标签页 -->
    <el-tabs v-model="activeTab" class="plan-tabs" @tab-click="handleTabChange">
      <el-tab-pane label="我的计划" name="myPlan">
        <!-- 搜索和表格内容移到外面，两个标签页共用 -->
      </el-tab-pane>

      <el-tab-pane label="我的审批" name="myApproval">
        <!-- 移除空内容 -->
      </el-tab-pane>
    </el-tabs>

    <!-- 搜索栏和表格移到这里，让两个标签页共用 -->
    <el-card class="search-card">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="计划编号">
          <el-input v-model="searchForm.keyword" placeholder="请输入计划编号" clearable></el-input>
        </el-form-item>
        <el-form-item label="部门">
          <el-select v-model="searchForm.department" placeholder="请选择部门" clearable>
            <el-option label="财务部/财务组" value="财务部/财务组"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类">
          <el-select v-model="searchForm.category" placeholder="请选择分类" clearable>
            <el-option label="物联网卡" value="物联网卡"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model.number="searchForm.status" placeholder="请选择状态" clearable>
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="已通过" :value="3"></el-option>
            <el-option label="待审核" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 表格 -->
    <el-card class="table-card">
      <div class="table-operations">
        <el-button type="primary" @click="handleAdd" v-if="activeTab === 'myPlan'">新建计划</el-button>
      </div>
      <el-table :data="tableData" style="width: 100%" border v-loading="loading" >
        <el-table-column prop="planName" label="计划名称" width="180" align="center"></el-table-column>
        <el-table-column prop="departmentPath" label="部门" width="180"align="center"></el-table-column>
        <el-table-column prop="categoryLabel" label="分类"align="center"></el-table-column>
        <el-table-column label="工作流" align="center">
        <template slot-scope="{row}">
          <el-tag size="medium" :type="row.status === 1 ? 'success' : 'info'" style="cursor: pointer"
            @click="handleShowFlow(row)">
            {{ row.workFlowName }}
            <i class="el-icon-arrow-right el-icon--right"></i>
          </el-tag>
        </template>
      </el-table-column>
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)">
              {{ getStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createAt" label="创建时间" align="center"></el-table-column>
        <el-table-column prop="approveTime" label="审核时间" align="center"></el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="{row}">
            <!-- 我的计划标签页的操作按钮 -->
            <template v-if="activeTab === 'myPlan'">
              <el-dropdown @command="(command) => handleCommand(command, row)">
                <span class="el-dropdown-link">
                  处理<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="view">
                    <i class="el-icon-view"></i> 查看
                  </el-dropdown-item>
                  <el-dropdown-item command="edit" v-if="row.status === 1">
                    <i class="el-icon-edit"></i> 编辑
                  </el-dropdown-item>
                  <el-dropdown-item command="detail" v-if="row.status === 1">
                    <i class="el-icon-document"></i> 明细
                  </el-dropdown-item>
                  <el-dropdown-item command="submit" v-if="row.status === 1">
                    <i class="el-icon-check"></i> 提交计划
                  </el-dropdown-item>
                  <el-dropdown-item command="cancel" divided v-if="row.status === 1">
                    <span style="color: #F56C6C;">
                      <i class="el-icon-close"></i> 取消
                    </span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>

            <!-- 我的审批标签页的操作按钮 -->
            <template v-else>
              <el-dropdown @command="(command) => handleApprovalCommand(command, row)">
                <span class="el-dropdown-link">
                  处理<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="view">
                    <i class="el-icon-view"></i> 查看
                  </el-dropdown-item>
                  <!-- <el-dropdown-item command="approve" v-if="[2, 3].includes(row.status)">
                    <i class="el-icon-check"></i> 审核
                  </el-dropdown-item> -->
                  <el-dropdown-item command="cancel" divided v-if="[2, 3].includes(row.status)">
                    <span style="color: #F56C6C;">
                      <i class="el-icon-close"></i> 取消
                    </span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchForm.page"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="searchForm.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>

    <!-- 添加工作流弹窗 -->
    <!-- 流程对话框 -->
    <el-dialog title="审批流程" :visible.sync="flowDialogVisible" width="700px" class="flow-dialog">
      <div v-loading="flowLoading">
        <el-timeline>
          <el-timeline-item v-for="(flow, index) in flowList" :key="index" :type="getTimelineNodeType(flow.status)"
            size="large">
            <div class="flow-item">
              <!-- 节点标题和状态 -->
              <div class="flow-header">
                <span class="flow-title">
                  <span class="step-tag">步骤 {{ flow.step }}</span>
                  {{ flow.title }}
                </span>
                <el-tag size="mini" :type="getStatusTagType(flow.status)">
                  {{ flow.statusText }}
                </el-tag>
              </div>

              <!-- 审批人信息 -->
              <div class="flow-content">
                <div class="flow-info">
                  <div class="info-header">
                    <i class="el-icon-user"></i>
                    <span>审批人</span>
                  </div>
                  <div class="approver-list">
                    <template v-if="flow.approverDetails && flow.approverDetails.length">
                      <div v-for="(approver, idx) in flow.approverDetails" :key="idx" class="approver-item">
                        <div class="approver-info">
                          <!-- 审批人名字和状态 -->
                          <div class="approver-row">
                            <span class="approver-name">{{ approver.name }}</span>
                            <el-tag size="mini" :type="getStatusTagType(approver.status)">
                              {{ getApproverStatusText(approver.status) }}
                            </el-tag>
                            <span class="approve-time">
                              {{ approver.time ? formatDateTime(approver.time) : '' }}
                            </span>
                          </div>
                          <!-- 审核意见直接跟在审批人下方 -->
                          <div v-if="approver.comment" class="approve-comment">
                            审核意见：{{ approver.comment }}
                          </div>
                        </div>
                      </div>
                    </template>
                    <span v-else class="no-approver">待处理</span>
                  </div>
                </div>
              </div>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-dialog>

    <!-- 新建计划弹框 -->
    <el-dialog 
      :title="dialogTitle" 
      :visible.sync="addPlanDialogVisible" 
      width="600px"
      :close-on-click-modal="false"
      :before-close="handleCloseAddDialog">
      <div class="add-plan-form" v-loading="addPlanLoading">
        <el-form 
          ref="planForm" 
          :model="planForm" 
          :rules="planRules" 
          label-width="80px"
          size="small">
          <!-- 计划名称 -->
          <el-form-item label="计划名称" prop="planName" class="required-label">
            <el-input 
              v-model="planForm.planName" 
              placeholder="请输入计划名称">
            </el-input>
          </el-form-item>

          <!-- 工作流 -->
          <el-form-item label="工作流" prop="workflowId" class="required-label">
            <el-select 
              v-model="planForm.workflowId" 
              placeholder="请选择工作流"
              filterable
              style="width: 100%">
              <el-option
                v-for="item in workflowOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id">
                <span>{{ item.name }}</span>
              </el-option>
            </el-select>
          </el-form-item>

          <!-- 部门 -->
          <el-form-item label="部门" prop="departmentId" class="required-label">
            <el-cascader
              v-model="planForm.departmentId"
              :options="departmentOptions"
              :props="{
                checkStrictly: true,
                value: 'id',
                label: 'label',
                children: 'children',
                emitPath: false
              }"
              clearable
              filterable
              placeholder="请选择部门"
              style="width: 100%">
            </el-cascader>
          </el-form-item>

          <!-- 分类 -->
          <el-form-item label="分类" prop="categoryId" class="required-label">
            <el-select 
              v-model="planForm.categoryId" 
              placeholder="请选择分类"
              filterable
              style="width: 100%">
              <el-option
                v-for="item in categoryOptions"
                :key="item.id"
                :label="item.name"
                :value="item.value">
                <span>{{ item.name }}</span>
              </el-option>
            </el-select>
          </el-form-item>

          <!-- 优先级 -->
          <el-form-item label="优先级" prop="priority">
            <el-rate
              v-model="planForm.priority"
              :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
              :texts="['低', '中', '高']"
              show-text>
            </el-rate>
          </el-form-item>

          <!-- 备注 -->
          <el-form-item label="备注" prop="remark">
            <el-input
              type="textarea"
              v-model="planForm.remark"
              :rows="4"
              placeholder="请输入备注信息">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCloseAddDialog">取消</el-button>
        <el-button type="primary" @click="submitPlan">确定</el-button>
      </div>
    </el-dialog>

    <!-- 修改审批弹窗 -->
    <el-dialog
      title="审核采购计划"
      :visible.sync="approveDialogVisible"
      width="400px"
      :close-on-click-modal="false"
      custom-class="approve-dialog">
      <el-input
        type="textarea"
        v-model="approveForm.remark"
        :rows="2"
        placeholder="请输入审核意见">
      </el-input>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="approveDialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitApprove(1)">通过</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'MyPlan',
  data() {
    return {
      flowDialogVisible: false,
      flowLoading: false,
      flowList: [],
      activeTab: 'myPlan',
      loading: false,
      searchForm: {
        page: 1,
        size: 10,
        keyword: '',
        department: '',
        category: '',
        status: -1,
        type: 1
      },
      tableData: [],
      total: 0,
      workflowDialogVisible: false,
      workflowSteps: [],
      addPlanDialogVisible: false,
      addPlanLoading: false,
      planForm: {
        planName: '',
        workflowId: '',
        departmentId: '',
        categoryId: '',
        priority: 1,
        remark: ''
      },
      planRules: {
        planName: [
          { required: true, message: '请输入计划名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        workflowId: [
          { required: true, message: '请选择工作流', trigger: 'change' }
        ],
        departmentId: [
          { required: true, message: '请选择部门', trigger: 'change' }
        ],
        categoryId: [
          { required: true, message: '请选择分类', trigger: 'change' }
        ]
      },
      departmentOptions: [],
      categoryOptions: [],
      workflowOptions: [],
      fileList: [],
      uploadUrl: process.env.VUE_APP_BASE_API + '/api/v1/file/upload',
      uploadHeaders: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      },
      isEdit: false,
      editingPlanId: '',
      approveDialogVisible: false,
      approveForm: {
        planId: '',
        remark: ''
      },
      approveRules: {
        result: [
          { required: true, message: '请选择审批结果', trigger: 'change' }
        ],
        remark: [
          { required: true, message: '请输入审批意见', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    // 从路由参数获取type并初始化
    const type = Number(this.$route.query.type) || 1
    this.searchForm.type = type
    this.activeTab = type === 1 ? 'myPlan' : 'myApproval'
    this.fetchData()
  },
  methods: {
    // 获取数据
    async fetchData() {
      try {
        this.loading = true
        const response = await request({
          url: '/api/v1/purchasing-plan/user-related-list',
          method: 'post',
          data: {
            page: this.searchForm.page,
            size: this.searchForm.size,
            keyword: this.searchForm.keyword,
            department: this.searchForm.department,
            category: this.searchForm.category,
            status: this.searchForm.status,
            type: this.searchForm.type  // 使用type区分数据来源
          }
        })

        if (response.status === 1) {
          this.tableData = response.list
          this.total = response.total
        }
      } catch (error) {
        console.error('获取数据失败:', error)
        this.$message.error('获取数据失败')
      } finally {
        this.loading = false
      }
    },

    // 搜索
    handleSearch() {
      this.searchForm.page = 1
      this.fetchData()
    },

    // 重置搜索表单
    resetForm() {
      this.searchForm = {
        page: 1,
        size: 10,
        keyword: '',
        department: '',
        category: '',
        status: -1,
        type: this.activeTab === 'myPlan' ? 1 : 2  // 保持当前标签页的type
      }
      this.fetchData()
    },

    // 处理分页
    handleSizeChange(val) {
      this.searchForm.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.searchForm.page = val
      this.fetchData()
    },

    // 状态转换
    getStatusType(status) {
      const statusMap = {
        1: 'info',         // 草稿
        2: 'warning',     // 待审核
        3: 'primary',     // 审核中
        4: 'success',    // 已通过
        5: 'danger',     // 已拒绝
        6: 'info',       // 已取消
   
 
      }
      return statusMap[status] || 'info'
    },

    getStatusText(status) {
      const statusMap = {
        1: '草稿',
        2: '待审核',
        3: '审核中',
        4: '已通过',
        5: '已拒绝',
        6: '已取消'
       
   
      }
      return statusMap[status] || '未知状态'
    },
    getApproverStatusText(status) {
      // 将 status 转换为数字类型，以确保正确匹配
      const statusNum = Number(status);

      const statusMap = {
        0: '未处理',
        1: '处理中',
        2: '已拒绝',
        3: '已通过',
        4: '已转交',
        5: '已回退',
        6: '已终止'
      }

      // 添加调试日志
      console.log('Approver status:', status, 'Mapped status:', statusMap[statusNum]);

      return statusMap[statusNum] || '未知状态';
    },

    // 格式化时间
    formatDateTime(date) {
      if (!date) return '-'
      const d = new Date(date)
      if (isNaN(d.getTime())) return '-'
      
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hour = String(d.getHours()).padStart(2, '0')
      const minute = String(d.getMinutes()).padStart(2, '0')
      const second = String(d.getSeconds()).padStart(2, '0')
      
      return `${year}/${month}/${day} ${hour}:${minute}:${second}`
    },
    // 切换标签页
    handleTabChange(tab) {
      // 根据标签页设置type
      this.searchForm.type = tab.name === 'myPlan' ? 1 : 2
      this.searchForm.page = 1  // 重置分页
      
      // 更新路由参数
      this.$router.push({
        query: {
          ...this.$route.query,
          type: this.searchForm.type
        }
      })
      
      this.fetchData()  // 获取新数据
    },

    // 处理操作
    handleProcess(row) {
      console.log('处理计划:', row)
      // 实现处理逻辑
    },

    async handleAdd() {
      this.isEdit = false
      this.editingPlanId = ''
      this.addPlanDialogVisible = true
      this.addPlanLoading = true
      // 重置表单数据
      this.planForm = {
        planName: '',
        workflowId: '',
        departmentId: '',
        categoryId: '',
        priority: 1,
        remark: ''
      }

      try {
        await Promise.all([
          this.fetchWorkflows(),
          this.fetchDepartments(),
          this.fetchCategories()
        ])
      } catch (error) {
        console.error('获取数据失败:', error)
        this.$message.error('获取数据失败')
      } finally {
        this.addPlanLoading = false
      }
    },

    // 获取部门列表
    async fetchDepartments() {
      try {
        const response = await request({
          url: '/api/v1/dept/list',
          method: 'post',
          data: {
            name: '',
            status: -1
          }
        })
        if (response && response.data) {
          this.departmentOptions = this.formatDepartmentData(response.data)
          console.log('部门树形数据:', this.departmentOptions)
        }
      } catch (error) {
        console.error('获取部门列表失败:', error)
        this.$message.error('获取部门列表失败')
      }
    },
    formatDepartmentData(data) {
      if (!Array.isArray(data)) {
        return [];
      }

      // 创建一个映射表来存储所有部门
      const deptMap = new Map();
      const result = [];

      // 首先将所有部门添加到映射表中
      data.forEach(item => {
        deptMap.set(item.dept_id, {
          id: item.dept_id,
          name: item.dept_name,
          label: item.dept_name,
          value: item.dept_id,
          parentId: item.parent_id || '0', // 如果 parent_id 为空字符串，设为 '0'
          children: [],
          // 添加其他可能需要的字段
          charger: item.charger,
          chargerPhone: item.charger_phone,
          chargerEmail: item.charger_email,
          status: item.status
        });
      });

      // 构建树形结构
      deptMap.forEach(dept => {
        const parent = deptMap.get(dept.parentId);
        if (parent && dept.parentId !== '0') {
          // 如果有父部门，将当前部门添加到父部门的 children 中
          parent.children.push(dept);
        } else if (dept.parentId === '0') {
          // 如果是顶级部门，直接添加到结果数组
          result.push(dept);
        }
      });

      // 递归函数：如果 children 为空数组则删除该属性
      const removeEmptyChildren = (nodes) => {
        nodes.forEach(node => {
          if (node.children.length === 0) {
            delete node.children;
          } else {
            removeEmptyChildren(node.children);
          }
        });
        return nodes;
      };

      // 对结果进行排序（可选）
      const sortDepartments = (nodes) => {
        nodes.sort((a, b) => a.label.localeCompare(b.label));
        nodes.forEach(node => {
          if (node.children) {
            sortDepartments(node.children);
          }
        });
        return nodes;
      };

      // 返回处理后的树形结构
      return sortDepartments(removeEmptyChildren(result));
    },

    // 获取分类列表
    async fetchCategories() {
      try {
        const response = await request({
          url: '/api/v1/dict/type',
          method: 'post',
          data: {
            dictItemName: '',
            dictType: 'CGLM'
          }
        })
        if (response.status === 1 && response.data) {
          // 格式化分类数据
          this.categoryOptions = response.data.map(item => ({
            id: item.itemId,            
            name: item.itemLabel,
            value: item.itemValue,
            label: item.itemLabel
          }))
        }
      } catch (error) {
        console.error('获取分类列表失败:', error)
        this.$message.error('获取分类列表失败')
      }
    },

    // 关闭弹框
    handleCloseAddDialog() {
      this.$confirm('确认关闭？未保存的数据将会丢失', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.addPlanDialogVisible = false
        this.$refs.planForm.resetFields()
        this.fileList = []
        // 重置编辑状态
        this.isEdit = false
        this.editingPlanId = ''
      }).catch(() => {})
    },

    // 文件上传前的验证
    // beforeUpload(file) {
    //   const isValidType = ['image/jpeg', 'image/png', 'application/pdf'].includes(file.type)
    //   const isLt10M = file.size / 1024 / 1024 < 10

    //   if (!isValidType) {
    //     this.$message.error('只能上传 JPG/PNG/PDF 格式的文件!')
    //     return false
    //   }
    //   if (!isLt10M) {
    //     this.$message.error('文件大小不能超过 10MB!')
    //     return false
    //   }
    //   return true
    // },

    // 文件上传成功
    // handleUploadSuccess(response, file, fileList) {
    //   if (response.status === 1) {
    //     this.planForm.attachments.push(response.data.fileId)
    //     this.$message.success('文件上传成功')
    //   } else {
    //     this.$message.error(response.message || '文件上传失败')
        // 从文件列表中移除上传失败的文件
    //     const index = fileList.indexOf(file)
    //     fileList.splice(index, 1)
    //   }
    // },

    // 文件上传失败
    // handleUploadError(err) {
    //   console.error('文件上传失败:', err)
    //   this.$message.error('文件上传失败')
    // },

    // 提交计划
    async submitPlan() {
      try {
        await this.$refs.planForm.validate()
        
        this.addPlanLoading = true
        const response = await request({
          url: '/api/v1/purchasing-plan/save',
          method: 'post',
          data: {
            plan_name: this.planForm.planName,
            plan_no: '', // 计划编号，由后端生成
            status: 1,  // 1表示草稿状态
            remark: this.planForm.remark || '',
            work_flow_id: this.planForm.workflowId,
            negotiated_amount: 0, // 默认金额为0
            department: this.planForm.departmentId,
            category: this.planForm.categoryId,
            priority: this.planForm.priority || 1,
            // 如果是编辑模式，添加计划ID
            ...(this.isEdit ? { plan_id: this.editingPlanId } : {})
          }
        })

        if (response.data.status === 1) {
          this.$message.success(this.isEdit ? '更新成功' : '创建成功')
          this.addPlanDialogVisible = false
          this.$refs.planForm.resetFields()
          // 重置表单数据
          this.planForm = {
            planName: '',
            workflowId: '',
            departmentId: '',
            categoryId: '',
            priority: 1,
            remark: ''
          }
          // 重置编辑状态
          this.isEdit = false
          this.editingPlanId = ''
          // 刷新列表数据
          await this.fetchData()
        } else {
          throw new Error(response.message || (this.isEdit ? '更新失败' : '创建失败'))
        }
      } catch (error) {
        console.error(this.isEdit ? '更新计划失败:' : '创建计划失败:', error)
        this.$message.error(error.message || (this.isEdit ? '更新失败' : '创建失败'))
      } finally {
        this.addPlanLoading = false
      }
    },

    // 查看详情
    handleView(row) {
      console.log('查看详情:', row)
      this.$router.push({
        path: '/purchase/myplan/detail',
        query: { planId: row.planId }
      })
    },

    // 编辑计划
    async handleEdit(row) {
      this.isEdit = true
      this.editingPlanId = row.plan_id
      this.addPlanDialogVisible = true
      this.addPlanLoading = true

      try {
        // 并行获取所有必要的数据
        await Promise.all([
          this.fetchWorkflows(),
          this.fetchDepartments(),
          this.fetchCategories()
        ])

        // 填充表单数据
        this.planForm = {
          planName: row.planName,
          workflowId: row.workFlowName,
          departmentId: row.department,
          categoryId: row.category,
          priority: row.priority || 1,
          remark: row.remark || ''
        }
      } catch (error) {
        console.error('获取数据失败:', error)
        this.$message.error('获取数据失败')
      } finally {
        this.addPlanLoading = false
      }
    },

    // 取消计划
    async handleCancel(row) {
      try {
        await this.$confirm('确认取消该计划?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        const res = await request({
          url: '/api/v1/purchasing-plan/cancel',
          method: 'post',
          data: {
            planId: row.id
          }
        })

        if (res.status === 1) {
          this.$message.success('取消成功')
          this.fetchPlanList() // 刷新列表
        } else {
          this.$message.error(res.msg || '取消失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('取消计划失败:', error)
          this.$message.error('取消失败')
        }
      }
    },

    // 提交计划
    // handleSubmit(row) {
    //   this.$confirm('确认提交该计划吗？', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(async () => {
    //     try {
    //       const response = await request({
    //         url: '/api/v1/purchasing-plan/submit',
    //         method: 'post',
    //         data: {
    //           planId: row.planId
    //         }
    //       })
    //       if (response.status === 1) {
    //         this.$message.success('提交成功')
    //         this.fetchPlanList()
    //       }
    //     } catch (error) {
    //       console.error('提交计划失败:', error)
    //       this.$message.error(error.message || '提交失败')
    //     }
    //   }).catch(() => {})
    // },


    handleSubmit(row) {
      // 检查状态是否为草稿(1)或已拒绝(5)
      if (row.status !== 1 && row.status !== 5) {
        this.$message.error('当前状态不允许提交')
        return
      }

      this.$confirm(row.status === 1 ? '确认提交该采购计划?' : '确认重新提交该采购计划?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: '/api/v1/purchasing-plan/submit',
          method: 'POST',
          data: {
            planId: row.planId,
            status: 2  // 提交后状态变为待审核
          }
        }).then(response => {
          if (response.status === 1) {
            this.$message({
              type: 'success',
              message: row.status === 1 ? '提交成功' : '重新提交成功'
            })
            this.fetchData()// 刷新列表
          } 
          // else {
          //   this.$message.error(response.msg || '提交失败')
          // }
        }).catch(error => {
          console.error('提交失败:', error)
          this.$message.error(error.response?.data?.msg || '提交失败')
        })
      })
    },

    // 获取时间线节点类型
    async handleShowFlow(row) {
      this.flowLoading = true
      this.flowDialogVisible = true

      try {
        // 检查是否有工作流数据
        if (row.workflow?.nodes && row.workflow.nodes.length > 0) {
          this.flowList = row.workflow.nodes.map(node => {
            return {
              title: `${node.nodeName} ${this.getNodeTypeText(node.nodeType)}`,  // 节点名称和类型
              step: node.step,       // 节点步骤
              status: node.status,   // 节点状态
              statusText: this.getNodeStatusText(node.status),//节点
              nodeType: node.nodeType,//节点类型
              isActive: node.isActive,//是否激活
              isCompleted: node.isCompleted,//是否完成
              // 处理审批人数组
              approverDetails: node.approvers?.map(approver => ({
                name: approver.approverName,//审批人名称
                status: Number(approver.status),//审批人状态
                time: approver.approveTime,//审批时间
                comment: approver.remark || ''//审批意见
              })) || []
            }
          })
        } else {
          this.flowList = [{
            title: '暂无流程数据',
            step: 1,
            status: 0,
            statusText: '未开始',
            approverDetails: []
          }]
        }
      } catch (error) {
        console.error('处理流程数据失败:', error)
        this.$message.error('处理流程数据失败')
      } finally {
        this.flowLoading = false
      }
    },

   // 获取状态标签类型
    getStatusTagType(status) {
      const typeMap = {
        0: 'info',    // 未处理
        1: 'warning', // 处理中
        2: 'danger',  // 已拒绝
        3: 'success', // 已通过
        4: 'info',    // 已转交
        5: 'warning'  // 已回退
      }
      return typeMap[status] || 'info'
    },
    // 获取节点类型和名称
    getNodeTypeText(nodeType) {
        const typeMap = {
        1: '(串行审批)',
        2: '(并行与)',
        3: '(并行或)'
      }
      return typeMap[nodeType] || ''
    },
       // 获取节点状态
       getNodeStatusText(status) {
      const statusMap = {
        0: '未开始',
        1: '进行中',
        2: '已完成',
        3: '已拒绝',
        4: '已取消'
      }
      return statusMap[status] || '未知状态'
    },

    // 获取时间轴节点类型
    getTimelineNodeType(status) {
      switch (status) {
        case 2: return 'success'  // 已完成
        case 1: return 'primary'  // 进行中
        case 0: return 'info'     // 未开始
        case 3: return 'danger'   // 已拒绝
        case 4: return 'warning'  // 已取消
        default: return 'info'
      }
    },

    // 获取时间轴项的颜色
    getTimelineItemColor(status) {
      return status === 3 ? '#67C23A' : status === 1 ? '#E6A23C' : '#409EFF'
    },

    // 统一的命令处理方法
    handleCommand(command, row) {
      switch (command) {
        case 'view':
          this.handleView(row)
          break
        case 'edit':
          this.handleEdit(row)
          break
        case 'detail':
          // 跳转到计划详情页面
          this.$router.push({
            path: `/purchase/plan/detail/${row.planId}`,
            query: { 
              from: 'myplan',  // 标记来源，用于返回按钮
              mode: 'detail'   // 标记模式为明细
            }
          })
          break
        case 'submit':
          this.handleSubmit(row)
          break
        case 'cancel':
          this.handleCancel(row)
          break
      }
    },

    // 添加获取工作流列表的方法
    async fetchWorkflows() {
      try {
        const response = await request({
          url: '/api/v1/process/by-type',
          method: 'post',
          data: {
            code: '100003' 
          }
        })
        if (response.status === 1 && response.data) {
          // 格式化工作流数据
          this.workflowOptions = response.data.map(item => ({
            id: item.processId,
            name: item.processName,
            value: item.processId,
            label: item.processName
          }))
        }
      } catch (error) {
        console.error('获取工作流列表失败:', error)
        this.$message.error('获取工作流列表失败')
      }
    },

    // 添加审批页面的命令处理方法
    handleApprovalCommand(command, row) {
      switch (command) {
        case 'view':
          this.handleView(row)
          break
        case 'approve':
          this.handleApprove(row)
          break
        case 'cancel':
          this.handleCancel(row)
          break
      }
    },

    // 修改审核处理方法
    handleApprove(row) {
      this.$confirm('', '审核采购计划', {
        confirmButtonText: '通过',
        cancelButtonText: '驳回',
        type: 'warning',
        showClose: true,
        distinguishCancelAndClose: true,
        showInput: true,
        inputPlaceholder: '请输入审核意见',
        customClass: 'approve-dialog',
        beforeClose: (action, instance, done) => {
          if (action === 'close') {
            done()
            return
          }

          if (!instance.inputValue) {
            this.$message.warning('请输入审核意见')
            return
          }

          if (action === 'confirm') {
            // 点击"通过"按钮
            request({
              url: '/api/v1/purchasing-plan/approve',
              method: 'POST',
              data: {
                planId: row.planId,        // 采购计划ID
                approved: 2,               // 审核结果：2-同意
                comment: instance.inputValue // 审批意见
              }
            }).then(response => {
              if (response.status === 1) {
                this.$message.success('审核通过')
                // 刷新我的审批列表
                this.fetchData()  // 先刷新列表
                done()  // 关闭对话框
              } else {
                if(response.status === 0){
                  this.$message.error(response.msg || '你不是当前审批人')
                }
              }
            })
          } else if (action === 'cancel') {
            // 点击"驳回"按钮
            request({
              url: '/api/v1/purchasing-plan/approve',
              method: 'POST',
              data: {
                planId: row.planId,        // 采购计划ID
                approved: 1,               // 审核结果：1-拒绝
                comment: instance.inputValue // 审批意见
              }
            }).then(response => {
              if (response.status === 1) {
                this.$message.success('已驳回')
                this.fetchData()  // 刷新列表
                done()
              }
            }).catch(() => {
              this.$message.error('操作失败')
            })
          }
        }
      })
    },

    // 提交审批
    async submitApprove(result) {
      try {
        const res = await request({
          url: '/api/v1/purchasing-plan/approve',
          method: 'post',
          data: {
            planId: this.planId,
            result: result, // 1: 通过, 2: 取回
            remark: this.approveForm.remark || '' 
          }
        })

        if (res.status === 1) {
          this.$message.success(result === 1 ? '审核通过成功' : '已驳回')
          this.approveDialogVisible = false
          this.fetchData() // 刷新列表
        } else {
          this.$message.error(res.msg || '操作失败')
        }
      } catch (error) {
        console.error('操作失败:', error)
        this.$message.error('操作失败')
      }
    }
  },
  computed: {
    dialogTitle() {
      return this.isEdit ? '编辑计划' : '新建计划'
    }
  }
}
</script>

<style lang="scss" scoped>
.my-plan-container {
  padding: 20px;
}

/* 渐变动画页头样式 */
.gradient-header {
  height: 80px;
  background: linear-gradient(90deg, #409EFF 0%, #40E0D0 100%);
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 24px;
  color: white;
  font-size: 18px;
  border-radius: 4px;
  margin-bottom: 20px;
  overflow: hidden;
}

/* 棋盘格纹理遮罩 */
.checkerboard-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: linear-gradient(45deg, rgba(255,255,255,0.1) 25%, transparent 25%), linear-gradient(-45deg, rgba(255,255,255,0.1) 25%, transparent 25%), linear-gradient(45deg, transparent 75%, rgba(255,255,255,0.1) 75%), linear-gradient(-45deg, transparent 75%, rgba(255,255,255,0.1) 75%);
  background-size: 20px 20px;
  background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
}

/* 内容层 */
.header-content {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
}

.header-icon {
  margin-right: 12px;
}

.header-icon i {
  font-size: 24px;
}

.plan-tabs {
  background: #fff;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 4px;
}

.search-card {
  margin-bottom: 20px;
}

.search-form {
  display: flex;
  flex-wrap: wrap;
}

.table-card {
  margin-bottom: 20px;
}

.table-operations {
  margin-bottom: 20px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

/* 添加按钮间距 */
.el-button + .el-button {
  margin-left: 10px;
}

/* 可选：鼠标悬停效果 */
.el-button:hover {
  opacity: 0.8;
}

/* 添加下拉菜单样式 */
.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
  font-size: 13px;

  &:hover {
    color: #66b1ff;
  }
}

.el-dropdown-menu {
  .el-dropdown-item {
    font-size: 13px;
    
    i {
      margin-right: 5px;
    }
  }
}

.workflow-dialog {
  border-radius: 8px;
}

.workflow-timeline {
  padding: 20px;
  max-height: 500px;
  overflow-y: auto;
}

.timeline-step {
  background: #f5f7fa;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 8px;
}

.step-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.step-title {
  font-weight: bold;
  color: #303133;
}

.approver-list {
  margin: 8px 0;
}

.approver-item {
  display: flex;
  align-items: center;
  margin: 4px 0;
  gap: 8px;
}

.approver-label,
.remark-label {
  color: #909399;
}


.approve-time {
  color: #909399;
  margin-left: 8px;
  font-size: 12px;
}

.approve-remark {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #EBEEF5;
}

.flow-dialog {
  .flow-container {
    padding: 20px 10px;
  }

  ::v-deep .el-timeline {
    padding: 0 20px;

    .el-timeline-item {
      padding-bottom: 25px;

      &:last-child {
        padding-bottom: 0;
      }

      .el-timeline-item__node {
        &--large {
          width: 14px;
          height: 14px;
        }

        &.is-success {
          background-color: #67C23A;
        }

        &.is-warning {
          background-color: #E6A23C;
        }

        &.is-danger {
          background-color: #F56C6C;
        }
      }

      .el-timeline-item__wrapper {
        padding-left: 25px;
      }

      .el-timeline-item__timestamp {
        color: #909399;
        font-size: 13px;
        margin-bottom: 8px;
      }
    }
  }

  .flow-item {
    background: #f8f9fa;
    border-radius: 4px;
    padding: 15px;
    margin-bottom: 10px;

    .flow-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;

      .flow-title {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 500;

        .step-tag {
          background: #ecf5ff;
          color: #409eff;
          padding: 2px 6px;
          border-radius: 4px;
          margin-right: 8px;
          font-size: 12px;
        }
      }
    }

    .flow-content {
      .flow-info {
        .info-header {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          color: #606266;

          i {
            margin-right: 5px;
          }
        }

        .approver-list {
          .approver-item {
            padding: 10px 0;
            border-bottom: 1px dashed #ebeef5;

            &:last-child {
              border-bottom: none;
            }

            .approver-info {
              display: flex;
              flex-direction: column;
              gap: 8px;
            }

            .approver-row {
              display: flex;
              align-items: center;
              gap: 12px;
            }

            .approve-comment {
              color: #606266;
              font-size: 13px;
              padding-left: 2px;
            }
          }
        }

        .no-approver {
          color: #909399;
          font-size: 13px;
        }
      }
    }
  }
}

/* 新建计划弹框样式 */
.add-plan-form {
  padding: 10px 20px;

  .required-label {
    ::v-deep .el-form-item__label:before {
      content: '*';
      color: #F56C6C;
      margin-right: 4px;
    }
  }

  .el-form-item {
    margin-bottom: 18px;
  }

  .el-rate {
    height: 32px;
    line-height: 32px;
  }

  .el-select {
    width: 100%;
  }

  .el-textarea__inner {
    font-family: inherit;
  }
}

.dialog-footer {
  text-align: right;
  padding-top: 10px;
  
  .el-button + .el-button {
    margin-left: 10px;
  }
}

.upload-demo {
  .el-upload__tip {
    color: #909399;
    font-size: 12px;
    margin-top: 5px;
  }
}

/* 确保弹框内的表单项间距合适 */
.el-form-item {
  margin-bottom: 22px;
}

/* 文本域样式 */
.el-textarea__inner {
  font-family: inherit;
}

/* 上传按钮样式 */
.el-upload {
  .el-button {
    margin-right: 10px;
  }
}

/* 审批弹窗样式 */
.approve-dialog {
  :deep(.el-dialog__header) {
    padding: 15px 20px;
    border-bottom: 1px solid #EBEEF5;
    
    .el-dialog__title {
      font-size: 16px;
      font-weight: 500;
    }
  }

  :deep(.el-dialog__body) {
    padding: 20px;
  }

  :deep(.el-textarea) {
    margin-bottom: 0;
    
    .el-textarea__inner {
      border: 1px solid #DCDFE6;
      border-radius: 4px;
      
      &:focus {
        border-color: #409EFF;
      }
    }
  }

  :deep(.dialog-footer) {
    text-align: right;
    padding: 10px 20px;
    border-top: 1px solid #EBEEF5;
    
    .el-button {
      padding: 9px 15px;
      font-size: 12px;
      border-radius: 4px;
      
      & + .el-button {
        margin-left: 10px;
      }
    }
  }
}
</style> 